export const DEFAULT_PERIOD_TYPE: string = 'Year';
export const DATA_SERVICES: any = {
  Profiles: 'Profiles',
  Covid: 'Covid',
};
